import {useState, useMemo, useEffect} from "react"
import {useTranslation} from "react-i18next"
import closeIcon from "../../assets/icon/close.svg"
import useEcpConfig from "../../swrCustomHooks/useEcpConfig"
import EcpConfigurationFilter from "../../tools/EcpConfigurationFilter"

export default function ValueSelector({setIsValueSelector, EcpNavigationTab, regenerate, idProject}) {
    const {t} = useTranslation()
    const {ecpConfig, isLoadingEcpConfig, isErrorEcpConfig} = useEcpConfig(idProject)
    const [value, setValue] = useState()

    const config = useMemo(() => {
        if (ecpConfig) {
            return EcpConfigurationFilter(EcpNavigationTab, ecpConfig)
        }
        return null
    }, [ecpConfig, EcpNavigationTab])

    useEffect(() => {
        config && setValue(config.nb_elements)
    }, [config])

    if (isErrorEcpConfig || isLoadingEcpConfig || ecpConfig?.message) return null
    return (
        <div className="value-selector" style={{top: EcpNavigationTab === "glossary" && "4.8%"}}>
            <img className="close-btn" src={closeIcon} alt="" onClick={() => setIsValueSelector(false)}/>
            <div className="infos">
                <h2 className="title">{t(`Number of ${EcpNavigationTab}`)}</h2>
                <p className="value">{value}</p>
            </div>
            {config && (
                <div className="slider">
                    <input
                        className="slider"
                        type="range"
                        min={config.min_elements}
                        max={config.max_elements}
                        value={value}
                        onChange={(e) => setValue(Number(e.target.value))}
                    />
                </div>
            )}
            <button onClick={() => regenerate(value)}>{t("Regenerate")}</button>
        </div>
    )
}